<template>
  <div class="balance">
    <div class="balance-card">
      <div class="balance-card-header">
        <div class="balance-card-header__title">报告查看</div>
        <div class="balance-card-header__tip">
          画像报告额度从会员购买时间节点起有效期为1年，详细服务请联系客服400-8566-100
        </div>
      </div>
      <div class="balance-card-body">
        <div class="balance-section">
          <div class="balance-section-text">
            画像报告可查看额度
            <el-tooltip
              class="item"
              effect="dark"
              popper-class="my_popper"
              placement="top"
            >
              <div slot="content">
                分析报告查看额度扣除方式为：每查看一个企业或采购<br />单位分析报告则扣除一个额度，在套餐规定的期限内，<br />已查看的企业可多次查看分析报告，不重复扣除额度。
              </div>
              <i class="iconfont icon-help text-cursor m-r-5"></i>
            </el-tooltip>
          </div>
          <div class="amount">
            {{ balance.remain || 0 }}
            <span class="amount-text">个</span>
          </div>
        </div>
        <div class="balance-section">
          <div class="balance-section-text">
            套餐内画像报告即将到期额度
            <el-tooltip
              class="item"
              effect="dark"
              popper-class="my_popper"
              placement="top"
            >
              <div slot="content" class="slot-content">
                套餐有效期小于或等于30天则视为即将到期，<br />请在到期前尽快使用。
              </div>
              <i class="iconfont icon-help text-cursor m-r-5"></i>
            </el-tooltip>
          </div>
          <div class="amount maturity-amount">
            {{ balance.willExpire || 0 }}
            <span class="amount-text">个</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="header">
        <div class="left">竞争对手 / 采购单位列表</div>
        <div class="right">
          <el-autocomplete
            v-model="localKeywords"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入竞争对手/采购单位名称"
            clearable
            @select="handleSelect"
            @clear="handleClear"
          >
            <template slot="append">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleSearch"
              />
            </template>
          </el-autocomplete>
        </div>
      </div>
      <template v-if="tabList.length > 0">
        <div v-for="(item, index) in tabList" :key="index" class="tab-item">
          <div class="line m-b-16"></div>
          <div class="top">
            <div class="companyName">
              <span v-if="item.companyInfo && item.companyInfo.companyName">{{
                item.companyInfo.companyName
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="portrait">
              <div class="portrait-text" @click="goPortrait(item, 'purchaser')">
                <i
                  class="iconfont icon-side_supplier_lib icon text-cursor m-r-5"
                ></i>
                查看采购单位报告
              </div>
              <div
                class="portrait-text m-l-32"
                @click="goPortrait(item, 'competitor')"
              >
                <i
                  class="iconfont icon-side_balance icon text-cursor m-r-5"
                ></i>
                查看竞争对手报告
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="item">
              注册地：
              <span v-if="item.companyInfo">
                <span v-if="item.companyInfo.province">{{
                  item.companyInfo.province
                }}</span>
                <span v-if="!item.companyInfo.province">-</span>
                <span v-if="item.companyInfo.city">{{
                  item.companyInfo.city
                }}</span>
                <span v-if="!item.companyInfo.city">-</span>
                <span v-if="item.companyInfo.district">{{
                  item.companyInfo.district
                }}</span>
                <span v-if="!item.companyInfo.district">-</span>
              </span>
              <span v-else>-</span>
            </div>
            <div class="m-l-10">
              注册资本：
              <span
                v-if="item.companyInfo && item.companyInfo.registeredCapital"
              >
                {{ strToThousands(item.companyInfo.registeredCapital) }} 元
              </span>
              <span v-else>-</span>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </template>
      <el-empty
        v-else
        description="暂无数据"
        :image="require('@/assets/images/personal-center/empty.png')"
        :image-size="64"
      />

      <div class="flex row-right">
        <jczh-pagination
          v-if="total > 0"
          style="text-align: right"
          :total="total"
          :page.sync="page"
          :limit.sync="size"
          @pagination="handlePagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryValueAddedServiceAccountBalanceApi,
  getPortraitRecordApi,
  getCompanyApi
} from '@/api/value-added-service'
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
import { mapState } from 'vuex'
import { strToThousands } from '@/utils/utils'

export default {
  name: 'PortraitRecord',

  data() {
    return {
      // 数据流量余额信息
      balance: {
        // 数据流量余额
        remain: 0,
        // 即将到期余额
        willExpire: 0
      },
      page: 1,
      size: 10,
      total: 0,
      tabList: [],
      localKeywords: '',
      companyId: ''
    }
  },

  computed: {
    ...mapState('system', ['consumerHotline'])
  },

  created() {
    this.getBidFilePreviewBalance()
    this.getPortraitRecord()
  },

  methods: {
    strToThousands,
    /**
     * 查询数据定制导出流量务余额
     */
    getBidFilePreviewBalance() {
      const params = valueAddedProductCodeDict.COMPANY_PORTRAIT.value
      queryValueAddedServiceAccountBalanceApi(params)
        .then(res => {
          this.balance = res.data || {
            remain: 0,
            willExpire: 0
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    getPortraitRecord() {
      // 1待支付 2已支付
      const params = {
        page: this.page,
        size: this.size,
        status: 2,
        companyId: this.companyId
      }
      getPortraitRecordApi(params)
        .then(res => {
          this.total = res.data.total
          this.tabList = res.data.records || []
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    handleSearch() {
      this.getPortraitRecord()
    },

    handleSelect(val) {
      this.companyId = val.companyId
    },

    querySearchAsync(queryString, cb) {
      const restaurants = []
      getCompanyApi({ keywords: queryString })
        .then(res => {
          if (res.data.records && res.data.records.length) {
            res.data.records.map(item => {
              item.value = item.companyName
              restaurants.push(item)
            })
          }
        })
        .catch(err => {
          if (err?.data?.message) this.$message.error(err.data.message)
        })
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(restaurants)
      }, 500 * Math.random())
    },

    handlePagination(val) {
      this.size = val.limit
      this.page = val.page
      this.getPortraitRecord()
    },

    goPortrait(item, type) {
      // 跳转至竞争对手画像详情
      if (type === 'competitor') {
        window.location.href = `${process.env.VUE_APP_BIDDOG_URL}/competitor-analysis/${item.companyId}/detail`
      }
      // 跳转至采购单位画像详情
      if (type === 'purchaser') {
        window.location.href = `${process.env.VUE_APP_BIDDOG_URL}/purchaser-analysis/${item.companyId}/detail`
      }
    },

    handleClear() {
      this.companyId = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.balance {
  width: 100%;
  .balance-card {
    width: 100%;
    border-radius: 4px;
    background: $white-color;
    padding: 24px;
    .balance-card-header {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      .balance-card-header__title {
        font-size: 16px;
        color: $text-color;
        @include text-bold;
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: $primary-color;
          margin-right: 6px;
          vertical-align: -12%;
        }
      }

      .balance-card-header__tip {
        font-size: 12px;
        color: $text-second-color;
        margin-left: 10px;
      }
    }

    .balance-card-body {
      display: flex;
      align-items: center;

      .balance-section {
        height: 88px;
        flex: 1;
        background: $info-fifth-color;
        border-radius: 4px;
        padding: 16px 24px;
        &:not(:last-child) {
          margin-right: 24px;
        }
        .balance-section-text {
          font-size: 14px;
          color: $text-color;
          font-weight: 400;
          display: flex;
          align-items: center;
          .icon-help {
            font-size: 20px;
            margin-left: 5px;
            color: $info-second-color;
            cursor: pointer;
          }
        }
        .amount {
          font-size: 24px;
          @include text-bold;
          color: $text-color;
          margin-top: 10px;
        }
        .maturity-amount {
          color: $warning-color;
        }
        .amount-text {
          font-size: 14px;
          @include text-bold;
          color: $text-color;
        }
      }
    }
  }

  .content {
    margin-top: 16px;
    border-radius: 4px;
    background: $white-color;
    box-sizing: border-box;
    padding: 24px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      ::v-deep {
        .el-input-group {
          width: 100%;
          min-width: 400px;
        }
        .el-input--small .el-input__inner {
          height: 32px;
          line-height: 32px;
          font-size: 16px;
        }
        .el-input__inner {
          &::placeholder {
            font-size: 14px;
          }
        }
        .el-input-group__append,
        .el-input-group__prepend {
          background: $primary-color;
          color: $white-color;
          border: 1px solid $primary-color;
          font-size: 16px;
        }
      }
      .left {
        font-size: 16px;
        color: $text-color;
        @include text-bold;
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: $primary-color;
          margin-right: 6px;
          vertical-align: -12%;
        }
      }
    }
    .tab-item {
      .top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        .companyName {
          font-size: 16px;
          color: $text-color;
          font-weight: 400;
        }
        .portrait {
          display: flex;
          color: #1890ff;
          font-weight: 400;
          font-size: 14px;
        }
        .portrait-text {
          cursor: pointer;
        }
      }
      .bottom {
        display: flex;
        font-weight: 400;
        font-size: 14px;
        color: $info-color;
        margin-bottom: 16px;
        .item {
          min-width: 300px;
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: $info-fourth-color;
    }
  }
}
</style>

<style lang="scss">
.my_popper {
  background: #000000;
  opacity: 0.8;
  color: $info-fifth-color;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
</style>
